import React from 'react';
import { cn } from '@h2/ui';
import Sidebar from './sidebar';
import ChatPanel from '../chat/ChatPanel';
import NotificationPanel from '../notification/NotificationPanel';
import { useSidebarStore } from '../../stores/useSidebarStore';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, className }) => {
  const { sidebarState } = useSidebarStore();

  const getMainMargin = () => {
    if (sidebarState === 'hidden') return 'ml-0';
    if (sidebarState === 'collapsed') return 'ml-16';
    return 'ml-44';
  };

  return (
    <div className={cn('min-h-screen bg-gray-50 dark:bg-gray-900', className)}>
      {/* Sidebar */}
      <div className="fixed top-0 left-0 z-40">
        <Sidebar />
      </div>

      {/* Main Content */}
      <main
        className={cn(
          'transition-all duration-300 ease-in-out min-h-screen',
          getMainMargin()
        )}
      >
        {children}
      </main>

      {/* Notification Panel */}
      <NotificationPanel />

      {/* Chat Panel */}
      <ChatPanel />
    </div>
  );
};

export default Layout;
